"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FieldLineStyle = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _base = _interopRequireDefault(require("../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const FormFieldStyle = _styledComponents.default.div`
  & + & {
    margin-top: 16px;
  }

  &&& {
    ${_styledSystem.space}
  }
`;
FormFieldStyle.defaultProps = {
  theme: _base.default
};
const FieldLineStyle = _styledComponents.default.div`
  ${({
  inline
}) => {
  if (inline) {
    return `
        display: flex;
      `;
  }

  return "display: block;";
}}
`;
exports.FieldLineStyle = FieldLineStyle;
var _default = FormFieldStyle;
exports.default = _default;